/**
 * The only file allowed to read `import.meta.env`. Jest swaps it for src/test/env.mock.ts.
 * Empty VITE_* URLs mean "same origin": Vite proxies /api, /_ and the service prefixes in dev,
 * Caddy in prod.
 */
export const env = {
  appName: import.meta.env.VITE_APP_NAME || "Blanqo",
  /** From the root package.json at build time (see vite.config.ts). */
  appVersion: import.meta.env.VITE_APP_VERSION ?? "dev",
  pocketbaseUrl: import.meta.env.VITE_POCKETBASE_URL || "/",
  /** Mailer prefix; only the dev inbox (/dev/mail) reads it in the browser. */
  mailUrl: import.meta.env.VITE_MAIL_URL || "/mail",
  aiUrl: import.meta.env.VITE_AI_URL || "/ai",
  /** Invoice preview/PDF rendering (services/pdf). */
  pdfUrl: import.meta.env.VITE_PDF_URL || "/pdf",
  billingUrl: import.meta.env.VITE_BILLING_URL || "/billing",
  /** The website (blanqo-web): legal pages. dev.blanqo.app for the dev app. */
  siteUrl: (import.meta.env.VITE_SITE_URL || "https://blanqo.app").replace(/\/$/, ""),
  /** Plausible site (e.g. app.blanqo.app). Empty disables analytics (dev, CI, e2e). */
  plausibleDomain: import.meta.env.VITE_PLAUSIBLE_DOMAIN || "",
  /** Sentry project DSN (public by design). Empty disables error reporting. */
  sentryDsn: import.meta.env.VITE_SENTRY_DSN || "",
  /** dev or prod for Sentry; empty locally. */
  deployEnv: import.meta.env.VITE_DEPLOY_ENV || "",
  isDev: import.meta.env.DEV,
  mode: import.meta.env.MODE,
} as const;
